<div class="tab-content" id="nav-tabContent">
  <div class="tab-pane fade show active" id="#nav-{{ name | lowercase }}" role="tabpanel" attr.aria-labelledby="nav-{{ name | lowercase }}-tab">
    <app-tab-carousel *ngIf="contentComponents" [id]="name" [components]="contentComponents" [featureComponents]="featureComponents" [activeFeature]="activeFeature"></app-tab-carousel>
  </div>
</div>


